/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {ToastContainer} from 'react-toastify'
import {toAbsoluteUrl} from '_metronic/helpers'
import {useAuth} from 'app/modules/auth'
import {useIntegrationManagement} from './config/useIntegrationManagement'
import {integrationCategories, renderActiveDrawer} from './config/integrationConfig'
import {useLocation} from 'react-router-dom'
import Searchbar from 'app/components/Searchbar'

type Props = {
  className: string
}

const IntegrationManagement: React.FC<Props> = ({className}) => {
  const {currentUser} = useAuth()
  const location = useLocation()

  const {
    filteredIntegrations,
    isModalOpen,
    selectedItemId,
    activeIntegration,
    searchTerm,
    setSearchTerm,
    selectedCategory,
    handleOpenModal,
    handleCloseModal,
    handleCategoryChange,
  } = useIntegrationManagement({
    currentUser,
  })

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const id = params.get('id')
    const service = params.get('service')

    if (id && service) {
      handleOpenModal(id, service)
    }
  }, [location.search])

  return (
    <>
      <div className='card-title mb-4'>
        {/* begin::Search */}
        <div
          className='d-flex justify-content-between align-items-center'
          data-kt-user-table-toolbar='base'
        >
          <div className='flex-lg-fill'>
            <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          <div className='d-flex justify-content-between align-items-center mb-4'>
            <label htmlFor='Integrations' className='fw-semibold fs-6 me-2'>
              Category
            </label>
            <select
              id='Integrations'
              className='form-select form-control w-auto'
              aria-label='Select Integrations'
              value={selectedCategory}
              onChange={(e) => handleCategoryChange(e.target.value)}
            >
              {integrationCategories.map((category) => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {filteredIntegrations && filteredIntegrations.length > 0 ? (
        <>
          {filteredIntegrations.map((item, index) => (
            <div key={index} className={`card mb-5 mb-xl-8`}>
              <div className='card-header border-0 pt-5 mb-5'>
                <div className='d-flex align-items-center'>
                  <div
                    className='d-inline-block position-relative me-5'
                    style={{
                      width: '45px',
                      height: '45px',
                      overflow: 'hidden',
                      backgroundColor: '#F6F6F6',
                      borderRadius: '10px',
                      padding: '6px',
                    }}
                  >
                    <img
                      src={toAbsoluteUrl(`${item.img_path}`)}
                      alt=''
                      loading='lazy'
                      style={{
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>

                  <div className='d-flex justify-content-start flex-column'>
                    <span className='card-label fw-bold fs-5'>{item.name}</span>
                    <span className='fw-semibold fs-6' style={{color: '#5A5A5A'}}>
                      {item.group}
                    </span>
                  </div>
                </div>

                <div className='mt-2'>
                  {item.status === 'Connected' ? (
                    <span className='badge border p-2 rounded-pill'>
                      <span
                        className={`badge border rounded-circle mx-2 bg-primary`}
                        style={{
                          width: '12px',
                          height: '12px',
                          padding: '3px',
                        }}
                      >
                        {' '}
                      </span>
                      <span className='text-center'>{item.status}</span>
                    </span>
                  ) : (
                    <span className='badge border p-2 rounded-pill'>
                      <span
                        className={`badge border rounded-circle mx-2 bg-danger`}
                        style={{
                          width: '12px',
                          height: '12px',
                          padding: '3px',
                        }}
                      >
                        {' '}
                      </span>
                      <span className='text-center'>Disconnected</span>
                    </span>
                  )}
                  <button
                    className='btn fw-semibold fs-6 mb-1 text-gray-900 text-hover-primary'
                    onClick={() => handleOpenModal(item.id, item.name)}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-settings mb-1'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z' />
                      <path d='M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0' />
                    </svg>{' '}
                    Manage
                  </button>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          <div className='container-fluid min-vh-50 d-flex align-items-center justify-content-center'>
            <div className='row' style={{height: '50vh', width: '100%'}}>
              <div className='col d-flex align-items-center justify-content-center'>
                <div className='text-center'>
                  <img
                    src='/media/integrations/Integrations Icon.svg'
                    alt='Integrations Icon'
                    className='mb-4'
                    style={{width: '60px'}}
                  />
                  <h2 className='fs-6 mb-2'>No integrations connected</h2>
                  <p className='fs-6' style={{color: '#5A5A5A'}}>
                    You'll see all your connected services here
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {renderActiveDrawer(activeIntegration, isModalOpen, selectedItemId, handleCloseModal)}
      <ToastContainer />
    </>
  )
}

export {IntegrationManagement}
